import React, { ReactNode, useContext, useEffect } from "react";

import qs from "qs";
import { matchRoutes } from "react-router-config";
import { useHistory, useLocation } from "react-router-dom";

import { initialUrl } from "../../shared/constants/AppConst";
import {
  NavStyle,
  ThemeMode,
  ThemeStyle,
} from "../../shared/constants/AppEnums";
import AppContextPropsType from "../../types/AppContextPropsType";
import { Loader } from "../index";
import AppContext from "./AppContext";
import { useAuthToken } from "./AppHooks";
import { checkPermission } from "./Utils";

interface AuthRoutesProps {
  children: ReactNode;
}

const AuthRoutes: React.FC<AuthRoutesProps> = ({ children }) => {
  const { pathname, search } = useLocation();
  const history = useHistory();
  const {
    routes,
    changeNavStyle,
    updateThemeStyle,
    initialPath,
    setInitialPath,
    updateThemeMode,
    setRTL,
  } = useContext<AppContextPropsType>(AppContext);

  const [loading, user] = useAuthToken();
  // const currentRoute = matchRoutes(routes, pathname)[0].route;
  // let isPermitted = checkPermission(currentRoute.auth, user ? user.role : null);
 let isPermitted = true

  useEffect(() => {
    function setInitPath() {
      if (
        initialPath === "/" &&
        ["/signin", "/signup"].indexOf(pathname) === -1
      ) {
        if (isPermitted) {
          setInitialPath(pathname);
        } else {
          setInitialPath(undefined);
        }
      }
    }

    setInitPath();
  }, [isPermitted, setInitialPath, initialPath, pathname]);

  useEffect(() => {
    function handleQueryParams() {
      const query = qs.parse(search.split("?")[1]);
      if (query.layout) {
        changeNavStyle(query.layout as NavStyle);
      }
      if (query.mode) {
        updateThemeMode(query.mode as ThemeMode);
      }
      if (query.rtl) {
        setRTL(true);
      }
      if (query.style) {
        updateThemeStyle!(query.style as ThemeStyle);
      }
    }

    if (search) {
      handleQueryParams();
    }
  }, [changeNavStyle, updateThemeMode, setRTL, updateThemeStyle, search]);

  useEffect(() => {
    if (!loading) {
      let PatientDetails = localStorage.getItem("PatientDetails");
      let token = "";

      if (PatientDetails) {
        let userdetails = JSON.parse(PatientDetails);
        token = userdetails["identificationKey"];
      }

      /*
      if (!user && !isPermitted) {

        console.log("before logoin1");
        history.push('/login'); // allowed route

      } else if (user && !isPermitted) {
        console.log("before logoin2");
        history.push('/error-pages/error-404'); // Not found
      } else if (user && isPermitted) {
        console.log("before logoin");
        if (
          pathname === '/' ||
          pathname === '/login' 
        ) {
          history.push(initialUrl);
        } else {
          // @ts-ignore
          if (
            initialPath &&
            initialUrl !== initialPath &&
            initialPath !== '/'
            // initialPath !== '/login' ||
            // initialPath !== '/signup')
          ) {
            history.push(initialPath);
          }
        }
      }*/

      if (!token) {
        // console.log("before logoin1::", pathname);
        if (!["/signin", "/signup", "/reset-password", "/verification", "/verificationSuccess", "/forgot-password", "/login"].includes(pathname) ){
          localStorage.setItem("redurectToLastActivePage", pathname);
        }
        
        

        if (
          pathname === "/signin" ||pathname === "/signup" ||
          pathname === "/reset-password" ||
          pathname === "/verification" ||
          pathname === "/verificationSuccess" ||
          pathname === "/forgot-password" ||
          pathname === "/appointment/mobile-video-consultation" ||
          pathname === "/appointment/book-new-appointment" ||
          pathname === "/appointment/book-followup" 
    
        ) {
          if(pathname === "/signup" && search !==""){
            localStorage.setItem('signupUsingMobileApp', 'yes');
          }
          if(pathname === "/forgot-password" && search !==""){
            localStorage.setItem('forgotPasswordUsingMobileApp', 'yes');
          }
          if(pathname === "/verification" && search !==""){
            localStorage.setItem('verificationUsingMobileApp', 'yes');
          }
          const validPaths = [
            "/appointment/mobile-video-consultation",
            "/appointment/book-new-appointment",
            "/appointment/book-followup"
          ];
          if(validPaths.includes(pathname)){
           if(search !==""){
            history.push(pathname+search);
           }else{
            history.push("/signin");
           }
          }else if(pathname === "/verification"){
            history.push(pathname+search);
          }
          else{
            history.push(pathname);
          }
        } else {
          if(localStorage.getItem('signupUsingMobileApp') === 'yes'){
            history.push("/signup");
          } else if(localStorage.getItem('forgotPasswordUsingMobileApp') === 'yes'){
            history.push("/forgot-password");
          } else{
            history.push("/signin");
          }
        }

        // allowed route
      } else if (token) {
        if(pathname === "/signup" && search !==""){
            localStorage.clear();
            localStorage.setItem('signupUsingMobileApp', 'yes');
            history.push("/signup");
        }

        if(pathname === "/forgot-password" && search !==""){
            localStorage.clear();
            localStorage.setItem('forgotPasswordUsingMobileApp', 'yes');
            history.push("/forgot-password");
        }
        if(pathname === "/verification" && search !==""){
          localStorage.clear();
          localStorage.setItem('verificationUsingMobileApp', 'yes');
          history.push("/verification"+search);
        }
        if (
          pathname === "/" ||
          pathname === "/signin" || 
          pathname === "/signup" ||
          pathname === "/reset-password" ||
          pathname === "/verification" ||
          pathname === "/verificationSuccess" ||
          pathname === "/forgot-password"
        ) {
          if(localStorage.getItem('WebViewUsingFor')==="appointmentBooking"){
            history.push('/appointment/book-new-appointment');
          }
          else if(localStorage.getItem('verificationUsingMobileApp')==="yes"){
            history.push("/verification"+search);
          }
          else{
            history.push(initialUrl);
          }
        } else {
          // console.log("before logoin111111");
          // @ts-ignore
          if (
            initialPath &&
            initialUrl !== initialPath &&
            initialPath !== "/"
            // initialPath !== '/login' ||
            // initialPath !== '/signup')
          ) {
            history.push(initialPath);
          }
        }
      }
    }
  }, [user, loading, initialPath, isPermitted, pathname, history]);

  return loading ? <Loader /> : <>{children}</>;
};

export default AuthRoutes;
